import { Component, input } from '@angular/core';
import { ContactLinkConfig } from '@shared/models';

@Component({
  selector: 'b2c-contact-link',
  styleUrl: './contact-link.component.scss',
  templateUrl: './contact-link.component.html',
})
export class ContactLinkComponent {
  config = input.required<ContactLinkConfig>();
}
